module.exports = __webpack_public_path__ + "static/media/c_maskbook.jpg - 快捷方式.51422218.lnk";